import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule }from '../../ng-zorro-antd/ng-zorro-antd.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ConfiguracaoComponent } from './configuracao.component';
@NgModule({
  declarations: [ConfiguracaoComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    NgZorroAntdModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [provideNgxMask()],
})
export class ConfiguracaoModule { }
